import React, { useState, useEffect } from "react";
import BasicColumnChart from "../../../../../components/chart/BasicColumnChart";
import { Card, Col } from "react-bootstrap";
import {
  GRAPH_FILL_COLOR,
  GRAPH_MINI_FILL_COLOR,
} from "../constant/graph-color-scheme";
import DonutChart from "../../../../../components/chart/DonutChart";
import TreeMapChart from "../../../../../components/chart/TreeMapChart";
import PolarChart from "../../../../../components/chart/PolarChart";
import {
  useGetLocationStateMap,
  useGetOverviewBrandClickReport,
  useGetOverviewBrandViewReport,
  useGetOverviewBrowserDistribution,
  useGetOverviewDeviceDistribution,
  useGetOverviewLandingCategory,
  useGetOverviewMobileDistribution,
  useGetOverviewViewCount,
  useGetOverviewZoneDistribution,
  useGetSummaryCampaignGroupList,
} from "../../../../../queries/query-hooks/workspace/brand-ads-hook";
import { useGetProjectDetails } from "../../../../../queries/query-hooks/workspace/workspace-hook";
import {
  formatLocalizedDate,
  formatNumberWithCommas,
  transformGraphData,
  transformHeatMapData,
} from "../../../../../common/utils/utils";
import TableHeaderSwiper from "../components/TableHeaderSwiper";
import BarChartSkeleton from "../../../../../skeleton/workspace/clirnet/brand-ads/bar-chart-skeleton";
import SquareChartSkeleton from "../../../../../skeleton/workspace/clirnet/brand-ads/square-chart-skeleton";
import MapAnalyticsSkeleton from "../../../../../skeleton/workspace/clirnet/brand-ads/map-analytics-skeleton";
import NavSwiperSkeleton from "../../../../../skeleton/workspace/clirnet/brand-ads/nav-swiper-skeleton";
import PageNotFound from "../../../../PageNotFound";
import { useParams } from "react-router-dom";
import Skeleton from "../../../../../components/skeleton";
import PieChart from "../../../../../components/chart/PieChart";
import * as dayjs from "dayjs";
import { ProjectHeaderTopBar } from "@ui";
import ProjectFilters from "../components/ProjectFilters";
import IndiaMap from "components/chart/IndiaMap";
import { useDispatch, useSelector } from "react-redux";
import { selectProject } from "store/project/project.selector";
import { updateProject } from "store/project/project.action";

function Overview() {
  function getGroupIdsCommaSeparated(data) {
    return data.map((item) => item.group_id).join(",");
  }

  const { project_id } = useParams();
  const dispatch = useDispatch();
  const project = useSelector(selectProject);
  const { data: projectDetails, isLoading: isProjectDetailsLoading } =
    useGetProjectDetails(project_id);

  const [activeCampaignGroup, setActiveCampaignGroup] = useState({});

  const [dateRangePayload, setDateRangePayload] = useState({
    start_date: "",
    end_date: "",
  });
  const [isProjectChange, setIsProjectChange] = useState(false);

  useEffect(() => {
    setIsProjectChange(true);
  }, [project_id]);

  const { data: viewReportdata, isLoading: isViewReportLoading } =
    useGetOverviewBrandViewReport(
      project_id,
      {
        start_date: dateRangePayload.start_date,
        end_date: dateRangePayload.end_date,
        campaign_list: activeCampaignGroup?.id,
      },
      activeCampaignGroup?.id &&
        !!dateRangePayload.start_date &&
        !!dateRangePayload.end_date
        ? true
        : false
    );

  const { data: viewCountdata, isLoading: isViewCountLoading } =
    useGetOverviewViewCount(
      project_id,
      {
        start_date: dateRangePayload.start_date,
        end_date: dateRangePayload.end_date,
        campaign_list: activeCampaignGroup?.id,
      },
      activeCampaignGroup?.id &&
        !!dateRangePayload.start_date &&
        !!dateRangePayload.end_date
        ? true
        : false
    );

  const { data: clickReportdata, isLoading: isClickReportLoading } =
    useGetOverviewBrandClickReport(
      project_id,
      {
        start_date: dateRangePayload.start_date,
        end_date: dateRangePayload.end_date,
        campaign_list: activeCampaignGroup?.id,
      },
      activeCampaignGroup?.id &&
        !!dateRangePayload.start_date &&
        !!dateRangePayload.end_date
        ? true
        : false
    );

  const { data: stateMapData, isLoading: isStateMapLoading } =
    useGetLocationStateMap(
      project_id,
      {
        start_date: dateRangePayload.start_date,
        end_date: dateRangePayload.end_date,
        campaign_list:
          projectDetails && projectDetails?.length > 0
            ? getGroupIdsCommaSeparated(projectDetails[0]?.project_group_data)
            : "",
        type: "percentage",
      },
      !!dateRangePayload.start_date && !!dateRangePayload.end_date
    );

  const {
    data: deviceDistributionData,
    isLoading: isDeviceDistributionLoading,
  } = useGetOverviewDeviceDistribution(
    project_id,
    {
      start_date: dateRangePayload.start_date,
      end_date: dateRangePayload.end_date,
      campaign_list:
        projectDetails && projectDetails?.length > 0
          ? getGroupIdsCommaSeparated(projectDetails[0]?.project_group_data)
          : "",
    },
    !!dateRangePayload.start_date && !!dateRangePayload.end_date
  );

  const {
    data: mobileDistributionData,
    isLoading: isMobileDistributionLoading,
  } = useGetOverviewMobileDistribution(
    project_id,
    {
      start_date: dateRangePayload.start_date,
      end_date: dateRangePayload.end_date,
      campaign_list:
        projectDetails && projectDetails?.length > 0
          ? getGroupIdsCommaSeparated(projectDetails[0]?.project_group_data)
          : "",
    },
    !!dateRangePayload.start_date && !!dateRangePayload.end_date
  );

  const { data: zoneDistributionData, isLoading: isZoneDistributionLoading } =
    useGetOverviewZoneDistribution(
      project_id,
      {
        start_date: dateRangePayload.start_date,
        end_date: dateRangePayload.end_date,
        campaign_list:
          projectDetails && projectDetails?.length > 0
            ? getGroupIdsCommaSeparated(projectDetails[0]?.project_group_data)
            : "",
      },
      !!dateRangePayload.start_date && !!dateRangePayload.end_date
    );

  const {
    data: browserDistributionData,
    isLoading: isBrowserDistributionLoading,
  } = useGetOverviewBrowserDistribution(
    project_id,
    {
      start_date: dateRangePayload.start_date,
      end_date: dateRangePayload.end_date,
      campaign_list:
        projectDetails && projectDetails?.length > 0
          ? getGroupIdsCommaSeparated(projectDetails[0]?.project_group_data)
          : "",
    },
    !!dateRangePayload.start_date && !!dateRangePayload.end_date
  );

  const { data: landingCategoryData, isLoading: isLandingCategoryLoading } =
    useGetOverviewLandingCategory(
      project_id,
      {
        start_date: dateRangePayload.start_date,
        end_date: dateRangePayload.end_date,
        campaign_list:
          projectDetails && projectDetails?.length > 0
            ? getGroupIdsCommaSeparated(projectDetails[0]?.project_group_data)
            : "",
      },
      !!dateRangePayload.start_date && !!dateRangePayload.end_date
    );

  const { data: campaignGroupList, isLoading: isCampaignGroupListLoading } =
    useGetSummaryCampaignGroupList(project_id, {
      campaign_list:
        projectDetails && projectDetails?.length > 0
          ? getGroupIdsCommaSeparated(projectDetails[0]?.project_group_data)
          : "",
    });

  const transformStateMapData = (data = [], key) => {
    return [
      data?.reduce((acc, item) => {
        if (item.name && item[key] !== null) {
          acc[item.name] = item[key];
        }
        return acc;
      }, {}),
    ];
  };

  const stateMapViewsData = transformStateMapData(
    stateMapData,
    "views_percent"
  );

  const zonalChartOptions =
    zoneDistributionData && zoneDistributionData?.length > 0
      ? transformHeatMapData(zoneDistributionData, "name", "user_count")
      : [];

  const totalViewsChartOptions = {
    colors: GRAPH_FILL_COLOR,
    series: [
      {
        name: "View Count",
        data:
          viewReportdata?.length > 0
            ? transformGraphData(viewReportdata, "Impression", "formatted_date")
                ?.series
            : [],
        color: "#3256b8", // Customize color for Net Profit
      },
    ],

    label:
      viewReportdata?.length > 0
        ? transformGraphData(viewReportdata, "Impression", "formatted_date")
            ?.label
        : [],
    title: "Views",
  };

  const totalClickChartOptions = {
    series: [
      {
        name: "Click Count",
        data:
          clickReportdata?.length > 0
            ? transformGraphData(clickReportdata, "click", "formatted_date")
                ?.series
            : [],
        color: "#1aa053",
      },
    ],
    label:
      clickReportdata?.length > 0
        ? transformGraphData(clickReportdata, "click", "formatted_date")?.label
        : [],
    title: "Clicks",
  };

  const deviceDistributionChartOptions = {
    series:
      deviceDistributionData?.length > 0
        ? transformGraphData(deviceDistributionData, "Device_count", "new_os")
            ?.series
        : [],
    label:
      deviceDistributionData?.length > 0
        ? transformGraphData(deviceDistributionData, "Device_count", "new_os")
            ?.label
        : [],
    title: "Device Distribution",
  };

  const pageCategoryChartOptions = {
    label:
      landingCategoryData && landingCategoryData?.length > 0
        ? transformGraphData(
            landingCategoryData,
            "pct_count",
            "Landing_page_type",
            false
          )?.label
        : [],
    series:
      landingCategoryData && landingCategoryData?.length > 0
        ? transformGraphData(
            landingCategoryData,
            "pct_count",
            "Landing_page_type"
          )?.series
        : [],
    title: "Impression by Landing Page Type",
  };

  const mobileDistributionChartOptions = {
    series:
      mobileDistributionData?.length > 0
        ? transformGraphData(mobileDistributionData, "os_count", "os")?.series
        : [],
    label:
      mobileDistributionData?.length > 0
        ? transformGraphData(mobileDistributionData, "os_count", "os")?.label
        : [],
    title: "Mobile Device Distribution",
  };

  const browserDistributionChartOptions = {
    label:
      browserDistributionData?.length > 0
        ? transformGraphData(
            browserDistributionData,
            "percentage",
            "new_browser"
          )?.label
        : [],
    series:
      browserDistributionData?.length > 0
        ? transformGraphData(
            browserDistributionData,
            "percentage",
            "new_browser"
          )?.series
        : [],
    title: "Browser Distribution",
  };

  useEffect(() => {
    if (projectDetails && projectDetails?.length > 0) {
      const today = dayjs();
      const projectEndDate = dayjs(projectDetails[0]?.project_end_date);
      let result = projectDetails[0]?.project_end_date;

      if (
        projectEndDate &&
        (projectEndDate.isAfter(today) || projectEndDate.isSame(today, "day"))
      ) {
        result = today.subtract(1, "day");
      } else {
        result = projectEndDate;
      }

      if (project?.start_date && project?.end_date && !isProjectChange) {
        setDateRangePayload({
          start_date: project?.start_date,
          end_date: project?.end_date,
        });
        dispatch(
          updateProject({
            start_date: project?.start_date,
            end_date: project?.end_date,
          })
        );
      } else {
        setDateRangePayload({
          start_date: formatLocalizedDate(
            new Date(projectDetails[0]?.project_start_date),
            "YYYY-MM-DD[T]00:00:00.000Z"
          ),
          end_date: formatLocalizedDate(
            new Date(result),
            "YYYY-MM-DD[T]23:59:59.000Z"
          ),
        });
        dispatch(
          updateProject({
            start_date: formatLocalizedDate(
              new Date(projectDetails[0]?.project_start_date),
              "YYYY-MM-DD[T]00:00:00.000Z"
            ),
            end_date: formatLocalizedDate(
              new Date(result),
              "YYYY-MM-DD[T]23:59:59.000Z"
            ),
          })
        );
        setIsProjectChange(false);
      }
    }
  }, [projectDetails, project_id]);

  const viewClickChartData = [
    {
      key: "views",
      data: viewReportdata,
      loading: isViewReportLoading,
      chartOptions: totalViewsChartOptions,
    },
    {
      key: "clicks",
      data: clickReportdata,
      loading: isClickReportLoading,
      chartOptions: totalClickChartOptions,
    },
  ];

  const viewClickAvailableCharts = viewClickChartData.filter(
    (item) => Array.isArray(item.data) && item.data.length > 0
  );

  const viewClickAllApisLoaded = viewClickChartData.every(
    (item) => !item.loading
  );

  const chartData = [
    {
      key: "landing",
      data: landingCategoryData,
      loading: isLandingCategoryLoading,
    },
    {
      key: "mobile",
      data: mobileDistributionData,
      loading: isMobileDistributionLoading,
    },
    // {
    //   key: "browser",
    //   data: browserDistributionData,
    //   loading: isBrowserDistributionLoading,
    // },
  ];

  const availableCharts = chartData.filter(
    (item) => Array.isArray(item.data) && item.data.length > 0
  );

  const allApisLoaded =
    !isLandingCategoryLoading &&
    !isMobileDistributionLoading &&
    !isBrowserDistributionLoading;

  return (
    <>
      <div className="row">
        <div className="col-sm-12">
          <ProjectHeaderTopBar
            projectType="Brand Ads"
            title="Analytics"
            projectStartDate={
              projectDetails?.length > 0
                ? projectDetails[0]?.project_start_date
                : ""
            }
            projectEndDate={
              projectDetails?.length > 0
                ? projectDetails[0]?.project_end_date
                : ""
            }
            isProjectDetailsLoading={isProjectDetailsLoading}
            rightComponent={
              <ProjectFilters
                title="Analytics"
                dateLabel={dateRangePayload}
                setDateRangePayload={setDateRangePayload}
                projectStartDate={
                  projectDetails?.length > 0
                    ? projectDetails[0]?.project_start_date
                    : ""
                }
                projectEndDate={
                  projectDetails?.length > 0
                    ? projectDetails[0]?.project_end_date
                    : ""
                }
                isProjectDetailsLoading={isProjectDetailsLoading}
              />
            }
          />
        </div>

        <div className="col-sm-12">
          {!isCampaignGroupListLoading && campaignGroupList.length > 0 ? (
            <TableHeaderSwiper
              className={"mb-3"}
              title={campaignGroupList}
              activeCampaignGroup={activeCampaignGroup}
              setActiveCampaignGroup={setActiveCampaignGroup}
            />
          ) : (
            <NavSwiperSkeleton />
          )}
        </div>

        {!viewClickAllApisLoaded ? (
          <Col>
            <div className="row row-cols-md-2">
              <div className="mb-4">
                <BarChartSkeleton />
              </div>
              <div className="mb-4">
                <BarChartSkeleton />
              </div>
            </div>
          </Col>
        ) : viewClickAvailableCharts.length > 0 ? (
          <Col>
            <div
              className={`row row-cols-md-${viewClickAvailableCharts.length}`}
            >
              {viewClickAvailableCharts.map((item) => (
                <div key={item.key} className="mb-4">
                  <BasicColumnChart
                    title={item.chartOptions.title}
                    series={item.chartOptions.series}
                    labels={item.chartOptions.label}
                  />
                </div>
              ))}
            </div>
          </Col>
        ) : null}

        <div className="col-sm-12 mb-4">
          <Card className="p-2 border bg-light bg-opacity-50 border-secondary border-opacity-10 mb-0">
            <Card.Body className="py-3">
              {isViewCountLoading ? (
                <Skeleton variant="text" height={30} width={"100%"} />
              ) : (
                <h5 className="text-center m-0 fs-5 fw-normal">
                  This Creative has gotten{" "}
                  {viewCountdata?.total_impressions > 0
                    ? formatNumberWithCommas(viewCountdata?.total_impressions)
                    : 0}{" "}
                  views since last {"month"}
                </h5>
              )}
            </Card.Body>
          </Card>
        </div>

        <div className="d-flex flex-column pe-2 col-lg-6 col-md-12 col-sm-12 mb-4">
          {!isStateMapLoading && stateMapData?.length > 0 ? (
            <IndiaMap
              stateData={stateMapViewsData}
              title={"Location"}
              valueSuffix="%"
            />
          ) : isStateMapLoading ? (
            <MapAnalyticsSkeleton />
          ) : null}
        </div>

        <div className="col-md-12 col-lg-6">
          <div className="row">
            <div className="mb-4 col-sm-12">
              {!isDeviceDistributionLoading &&
              deviceDistributionData?.length > 0 ? (
                <DonutChart
                  series={deviceDistributionChartOptions.series}
                  labels={deviceDistributionChartOptions.label}
                  title={deviceDistributionChartOptions.title}
                  graphColor={GRAPH_MINI_FILL_COLOR}
                  height={320}
                />
              ) : isDeviceDistributionLoading ? (
                <SquareChartSkeleton />
              ) : null}
            </div>
            <div className="col-sm-12 mb-4">
              {!isZoneDistributionLoading &&
              zoneDistributionData?.length > 0 ? (
                <TreeMapChart
                  title={"Zonal Distribution"}
                  series={zonalChartOptions}
                />
              ) : isZoneDistributionLoading ? (
                <SquareChartSkeleton />
              ) : null}
            </div>
          </div>
        </div>
        <Col>
          <div className={`row row-cols-md-${availableCharts.length}`}>
            {!allApisLoaded ? (
              <>
                <Col md={6} sm={12} className="mb-4">
                  <SquareChartSkeleton />
                </Col>
                <Col md={6} sm={12} className="mb-4">
                  <SquareChartSkeleton />
                </Col>
                {/* <Col md={4} sm={12} className="mb-4">
                  <SquareChartSkeleton />
                </Col> */}
              </>
            ) : (
              chartData.map(({ key, data, loading }) => {
                if (!Array.isArray(data) && !loading) return null;

                return (
                  <div key={key} className="mb-4">
                    {(() => {
                      switch (key) {
                        case "landing":
                          return !loading && data?.length > 0 ? (
                            <PieChart
                              labels={pageCategoryChartOptions.label}
                              series={pageCategoryChartOptions.series}
                              title={pageCategoryChartOptions.title}
                              graphColor={GRAPH_FILL_COLOR}
                              height={320}
                            />
                          ) : loading ? (
                            <SquareChartSkeleton />
                          ) : null;

                        case "mobile":
                          return !loading && data?.length > 0 ? (
                            <DonutChart
                              series={mobileDistributionChartOptions.series}
                              labels={mobileDistributionChartOptions.label}
                              title={mobileDistributionChartOptions.title}
                              graphColor={GRAPH_MINI_FILL_COLOR}
                              height={320}
                            />
                          ) : loading ? (
                            <SquareChartSkeleton />
                          ) : null;

                        // case "browser":
                        //   return !loading && data?.length > 0 ? (
                        //     <PolarChart
                        //       labels={browserDistributionChartOptions.label}
                        //       series={browserDistributionChartOptions.series}
                        //       title={browserDistributionChartOptions.title}
                        //       graphColor={GRAPH_MINI_FILL_COLOR}
                        //       height={320}
                        //     />
                        //   ) : loading ? (
                        //     <SquareChartSkeleton />
                        //   ) : null;

                        default:
                          return null;
                      }
                    })()}
                  </div>
                );
              })
            )}
          </div>
        </Col>
      </div>
    </>
  );
}

export default Overview;
